import { Sizes } from '@blockanalitica/ui/package/types/src/theme/sizes';

const sizes: Sizes = {
  '-5': '0.422rem',
  '-4': '0.5064rem',
  '-3': '0.6076rem',
  '-2': '0.7292rem',
  '-1': '0.875rem',
  '0': '1rem',
  '1': '1.26rem',
  '2': '1.512rem',
  '3': '1.8144rem',
  '4': '2.1773rem',
  '5': '2.6127rem',
  '6': '3.1353rem',
  '7': '3.7623rem',
  '8': '4.5148rem',
  '9': '5.4178rem',
  '10': '6.5'
};

export default sizes;
